import React from "react";
import { CalloutBoxContainer, CalloutBoxInner } from "./CalloutBox.styles";

interface CalloutBoxProps {
  position?: "right" | "middle" | "left";
  children: JSX.Element | React.ReactNode;
}

export function CalloutBox({ position = "right", children }: CalloutBoxProps) {
  return (
    <CalloutBoxContainer $position={position}>
      <CalloutBoxInner>{children}</CalloutBoxInner>
    </CalloutBoxContainer>
  );
}
